import { isAfter } from "date-fns";

import type { Absence , AbsenceTypeId} from "~/modules/absence/api/absence/absenceTypes.ts";
import { AbsenceTypeName } from "~/modules/absence/api/absence/absenceTypes.ts";
import { LONG_TERM_ABSENCE_TYPE_IDS } from "~/modules/absence/api/config/absenceConfig.ts";

const EDITABLE_ABSENCE_TYPE_NAMES = [AbsenceTypeName.Training, AbsenceTypeName.InternalEvent, AbsenceTypeName.Special];

/**
 * The UI calculates these rules itself: the backend gives no `ActionBlock` for an absence. The backend
 * checks the rule again on submit (`absenceIsDeletableOrUpdatableRule`), so a mismatch only costs a
 * refused request.
 */
export const getAbsenceActionRules = (
	absence: Absence,
	absenceTypeName: string | undefined,
	userCanManageAbsences: boolean,
) => {
	const isDeletable = userCanManageAbsences || isAfter(new Date(absence.startDate), new Date());

	const isEditable = LONG_TERM_ABSENCE_TYPE_IDS.includes(absence.absenceTypeId as AbsenceTypeId)
		? userCanManageAbsences
		: isDeletable || EDITABLE_ABSENCE_TYPE_NAMES.includes(absenceTypeName as AbsenceTypeName);

	return { isDeletable, isEditable };
};
